"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanDto = void 0;
class CanDto {
    constructor(canDto) {
        this.download = canDto.download;
        this.update = canDto.update;
        this.destroy = canDto.destroy;
        this.schedule = canDto.schedule;
        this.editContent = canDto.edit_content;
    }
    static get QUERY_FIELDS() {
        return 'download,update,schedule,destroy';
    }
}
exports.CanDto = CanDto;
